import { __assign } from "tslib";
import { pluginFactory } from '../../../../utils/plugin-state-factory';
import { pluginKey } from './plugin-key';
import reducer from './reducer';
function mapping(tr, pluginState) {
    if (pluginState && pluginState.resizeHandlePos !== null) {
        return __assign(__assign({}, pluginState), { resizeHandlePos: tr.mapping.map(pluginState.resizeHandlePos) });
    }
    return pluginState;
}
var factory = pluginFactory(pluginKey, reducer, {
    mapping: mapping,
});
export var createCommand = factory.createCommand;
export var createPluginState = factory.createPluginState;
export var getPluginState = factory.getPluginState;
//# sourceMappingURL=plugin-factory.js.map